import ITransferState from 'redux/fileUpload/interfaces/iTransferState';

const totalUploadSize = (state: ITransferState): number =>
  state.entries.reduce((acc, entry) => acc + entry.total, 0);

export default totalUploadSize;
